export type WorkEntryActorMember = {
  readonly name: string;
  readonly avatarSeed?: string;
  readonly imageUrl?: string;
};

/** Leading name in headings like `Morrow · Search web` or `Ayşe · Reviewed inbox`. */
export function parseWorkEntryHeadingActor(heading: string): string | null {
  const parts = heading.split(" · ");
  if (parts.length < 2) {
    return null;
  }
  const actor = parts[0]?.trim();
  return actor || null;
}

export function isMorrowBrandedActor(name: string): boolean {
  const normalized = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return normalized === "morrow" || normalized === "morrowos";
}

export function matchWorkEntryActorMember(
  actorName: string,
  members: readonly WorkEntryActorMember[],
): WorkEntryActorMember | null {
  const needle = actorName.trim().toLowerCase();
  if (!needle) {
    return null;
  }
  return members.find((member) => member.name.trim().toLowerCase() === needle) ?? null;
}
